import { fetchNotificationUsersEndPoint } from "../../../configuration";
import axiosInstance from "../../axiosInterceptor";

export const fetchAvailableAddUsers = async (activeSession) => {
  const response = await axiosInstance.post(fetchNotificationUsersEndPoint(), {
    accountName: activeSession?.accountId,
    filter: {
      $expand: "roles",
    },
  });
  let notificationUsersResponse = response?.status === 200 ? response.data : [];
  return notificationUsersResponse.length ? notificationUsersResponse : [];
};

export const fetchAvailableEditUsers = async (siteId, activeSession) => {
  const response = await axiosInstance.post(fetchNotificationUsersEndPoint(), {
    accountName: activeSession?.accountId,
    filter: {
      $selection: {
        rbacsiteid: siteId,
      },
      $expand: "roles",
    },
  });

  let notificationUsersResponse = response?.status === 200 ? response.data : [];
  return notificationUsersResponse.length ? notificationUsersResponse : [];
};
